import { animate, animateChild, group, query, state, style, transition, trigger } from "@angular/animations";
const optional={optional:true};
export const slideInAnimation =
  trigger('routeAnimations', [
    //transitions for HCV lob
    transition('void => isFuel', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          // bottom: '-20%',
        //   left: 0,
        top:'0%',
        // bottom:'0%',
          width: '100%'
        })
      ],optional),
      query(':enter', [
        style({ top: '100%' })
      ],optional),
      query(':leave', [animateChild()],optional),
      group([
        query(':leave', [
          animate('1000ms ease-out', style({ top: '-100%'}))
        ],optional),
        query(':enter', [
          animate('1200ms ease-out', style({ top: '0%'}))
        ],optional),
      ]),
    ]),
    transition('isFuel => operationAnimate, operationAnimate => isVehicleType, isVehicleType => isGvw, isGvw => isApplication, isApplication => isCabin, isCabin => isSpec', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          // bottom: '-20%',
        //   left: 0,
        top:'0%',
          width: '100%'
        })
      ],optional),
      query(':enter', [
        style({ top: '100%' })
      ],optional),
      query(':leave', [animateChild()],optional),
      group([
        query(':leave', [
          animate('1000ms ease-out', style({ top: '-100%' }))
        ],optional),
        query(':enter', [
          animate('1200ms ease-out', style({ top: '0%' }))
        ],optional),
      ]),
    ]),
    transition('operationAnimate => isFuel, isVehicleType => operationAnimate, isGvw => isVehicleType, isApplication => isGvw, isCabin => isApplication, isSpec => isCabin',[  
      style({ position: 'relative' }),
    query(':enter, :leave', [
      style({
        position: 'absolute',
        // bottom: '-20%',
      //   left: 0,
      top:'0%',
        width: '100%'
      })
    ],optional),
    query(':enter', [
      style({ top: '-100%' })
    ],optional),
    query(':leave', [animateChild()],optional),
    group([
      query(':leave', [
        animate('1000ms ease-out', style({ top: '100%' }))
      ],optional),
      query(':enter', [
        animate('1200ms ease-out', style({ top: '0%' }))
      ],optional),
    ]),]),

    //transitions for MAGIC lob
    transition('void => isMagicRoof', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          // bottom: '-20%',
        //   left: 0,
        top:'0%',
        // bottom:'0%',
          width: '100%'
        })
      ],optional),
      query(':enter', [
        style({ top: '100%'})
      ],optional),
      query(':leave', [animateChild()],optional),
      group([
        query(':leave', [
          animate('1000ms ease-out', style({ top: '-100%'}))
        ],optional),
        query(':enter', [
          animate('1200ms ease-out', style({ top: '0%' }))
        ],optional),
      ]),
    ]),
    transition('isMagicRoof => isMagicFuel, isMagicFuel => isMagicApplication', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          // bottom: '-20%',
        //   left: 0,
        top:'0%',
        // bottom:'0%',
          width: '100%'
        })
      ],optional),
      query(':enter', [
        style({ top: '100%'})
      ],optional),
      query(':leave', [animateChild()],optional),
      group([
        query(':leave', [
          animate('1000ms ease-out', style({ top: '-100%'}))
        ],optional),
        query(':enter', [
          animate('1200ms ease-out', style({ top: '0%' }))
        ],optional),
      ]),
    ]),
    transition('isMagicFuel => isMagicRoof, isMagicApplication => isMagicFuel',[  
      style({ position: 'relative' }),
    query(':enter, :leave', [
      style({
        position: 'absolute',
        // bottom: '-20%',
      //   left: 0,
      top:'0%',
        width: '100%'
      })
    ],optional),
    query(':enter', [
      style({ top: '-100%' })
    ],optional),
    query(':leave', [animateChild()],optional),
    group([
      query(':leave', [
        animate('1000ms ease-out', style({ top: '100%' }))
      ],optional),
      query(':enter', [
        animate('1200ms ease-out', style({ top: '0%' }))
      ],optional),
    ]),]),

    //transitions for WINGER lob

      transition('void => isWingerApplication', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          // bottom: '-20%',
        //   left: 0,
        top:'0%',
        // bottom:'0%',
          width: '100%'
        })
      ],optional),
      query(':enter', [
        style({ top: '100%'})
      ],optional),
      query(':leave', [animateChild()],optional),
      group([
        query(':leave', [
          animate('1000ms ease-out', style({ top: '-100%'}))
        ],optional),
        query(':enter', [
          animate('1200ms ease-out', style({ top: '0%' }))
        ],optional),
      ]),
    ]),
    transition('isWingerApplication => isWingerWheelBase, isWingerWheelBase => isWingerBodyType, isWingerBodyType => isWingerComfort, isWingerComfort => isWingerRoofType, isWingerRoofType => isWingerPassenger', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          // bottom: '-20%',
        //   left: 0,
        top:'0%',
        // bottom:'0%',
          width: '100%'
        })
      ],optional),
      query(':enter', [
        style({ top: '100%'})
      ],optional),
      query(':leave', [animateChild()],optional),
      group([
        query(':leave', [
          animate('1000ms ease-out', style({ top: '-100%'}))
        ],optional),
        query(':enter', [
          animate('1200ms ease-out', style({ top: '0%' }))
        ],optional),
      ]),
    ]),
    transition('isWingerWheelBase => isWingerApplication, isWingerBodyType => isWingerWheelBase, isWingerComfort => isWingerBodyType, isWingerRoofType => isWingerComfort, isWingerPassenger => isWingerRoofType',[  
      style({ position: 'relative' }),
    query(':enter, :leave', [
      style({
        position: 'absolute',
        // bottom: '-20%',
      //   left: 0,
      top:'0%',
        width: '100%'
      })
    ],optional),
    query(':enter', [
      style({ top: '-100%' })
    ],optional),
    query(':leave', [animateChild()],optional),
    group([
      query(':leave', [
        animate('1000ms ease-out', style({ top: '100%' }))
      ],optional),
      query(':enter', [
        animate('1200ms ease-out', style({ top: '0%' }))
      ],optional),
    ]),]),

      //transitions for ILMCV lob

      transition('void => isIlmcvFuel', [
        style({ position: 'relative' }),
        query(':enter, :leave', [
          style({
            position: 'absolute',
            // bottom: '-20%',
          //   left: 0,
          top:'0%',
          // bottom:'0%',
            width: '100%'
          })
        ],optional),
        query(':enter', [
          style({ top: '100%'})
        ],optional),
        query(':leave', [animateChild()],optional),
        group([
          query(':leave', [
            animate('1000ms ease-out', style({ top: '-100%'}))
          ],optional),
          query(':enter', [
            animate('1200ms ease-out', style({ top: '0%' }))
          ],optional),
        ]),
      ]),
      transition('isIlmcvApplication => isIlmcvCabinType', [
        style({ position: 'relative' }),
        query(':enter, :leave', [
          style({
            position: 'absolute',
            // bottom: '-20%',
          //   left: 0,
          top:'0%',
          // bottom:'0%',
            width: '100%'
          })
        ],optional),
        query(':enter', [
          style({ top: '100%'})
        ],optional),
        query(':leave', [animateChild()],optional),
        group([
          query(':leave', [
            animate('1000ms ease-out', style({ top: '-150%'}))
          ],optional),
          query(':enter', [
            animate('1200ms ease-out', style({ top: '0%' }))
          ],optional),
        ]),
      ]),
      transition('isIlmcvFuel => isIlmcvOperation, isIlmcvOperation => isIlmcvVehicleType, isIlmcvVehicleType => isIlmcvGvw, isIlmcvGvw => isIlmcvApplication, isIlmcvCabinType => isIlmcvLoadBody,isIlmcvLoadBody => isIlmcvSpec, isIlmcvSpec => isIlmcvBaseVehicle', [
        style({ position: 'relative' }),
        query(':enter, :leave', [
          style({
            position: 'absolute',
            // bottom: '-20%',
          //   left: 0,
          top:'0%',
          // bottom:'0%',
            width: '100%'
          })
        ],optional),
        query(':enter', [
          style({ top: '100%'})
        ],optional),
        query(':leave', [animateChild()],optional),
        group([
          query(':leave', [
            animate('1000ms ease-out', style({ top: '-100%'}))
          ],optional),
          query(':enter', [
            animate('1200ms ease-out', style({ top: '0%' }))
          ],optional),
        ]),
      ]),
      transition('isIlmcvOperation => isIlmcvFuel, isIlmcvVehicleType => isIlmcvOperation, isIlmcvGvw => isIlmcvVehicleType, isIlmcvApplication => isIlmcvGvw, isIlmcvCabinType => isIlmcvApplication, isIlmcvLoadBody => isIlmcvCabinType, isIlmcvSpec => isIlmcvLoadBody, isIlmcvBaseVehicle => isIlmcvSpec',[  
        style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          // bottom: '-20%',
        //   left: 0,
        top:'0%',
          width: '100%'
        })
      ],optional),
      query(':enter', [
        style({ top: '-100%' })
      ],optional),
      query(':leave', [animateChild()],optional),
      group([
        query(':leave', [
          animate('1000ms ease-out', style({ top: '100%' }))
        ],optional),
        query(':enter', [
          animate('1200ms ease-out', style({ top: '0%' }))
        ],optional),
      ]),]),

      //transitions for SCV-Cargo lob

      transition('void => isScvApplication', [
        style({ position: 'relative' }),
        query(':enter, :leave', [
          style({
            position: 'absolute',
            // bottom: '-20%',
          //   left: 0,
          top:'0%',
          // bottom:'0%',
            width: '100%'
          })
        ],optional),
        query(':enter', [
          style({ top: '100%'})
        ],optional),
        query(':leave', [animateChild()],optional),
        group([
          query(':leave', [
            animate('1000ms ease-out', style({ top: '-100%'}))
          ],optional),
          query(':enter', [
            animate('1200ms ease-out', style({ top: '0%' }))
          ],optional),
        ]),
      ]),
      transition('isScvApplication => isScvKms', [
        style({ position: 'relative' }),
        query(':enter, :leave', [
          style({
            position: 'absolute',
            // bottom: '-20%',
          //   left: 0,
          top:'0%',
          // bottom:'0%',
            width: '100%'
          })
        ],optional),
        query(':enter', [
          style({ top: '100%'})
        ],optional),
        query(':leave', [animateChild()],optional),
        group([
          query(':leave', [
            animate('1000ms ease-out', style({ top: '-150%'}))
          ],optional),
          query(':enter', [
            animate('1200ms ease-out', style({ top: '0%' }))
          ],optional),
        ]),
      ]),
      transition('isScvKms => isScvApplication', [
        style({ position: 'relative' }),
        query(':enter, :leave', [
          style({
            position: 'absolute',
            // bottom: '-20%',
          //   left: 0,
          top:'0%',
          // bottom:'0%',
            width: '100%'
          })
        ],optional),
        query(':enter', [
          style({ top: '100%'})
        ],optional),
        query(':leave', [animateChild()],optional),
        group([
          query(':leave', [
            animate('1000ms ease-out', style({ top: '100%'}))
          ],optional),
          query(':enter', [
            animate('1200ms ease-out', style({ top: '-70%' }))
          ],optional),
        ]),
      ]),
      transition('isScvKms => isScvDeckLength, isScvDeckLength => isScvBodyType, isScvBodyType => isScvBaseVehicle', [
        style({ position: 'relative' }),
        query(':enter, :leave', [
          style({
            position: 'absolute',
            // bottom: '-20%',
          //   left: 0,
          top:'0%',
          // bottom:'0%',
            width: '100%'
          })
        ],optional),
        query(':enter', [
          style({ top: '100%'})
        ],optional),
        query(':leave', [animateChild()],optional),
        group([
          query(':leave', [
            animate('1000ms ease-out', style({ top: '-100%'}))
          ],optional),
          query(':enter', [
            animate('1200ms ease-out', style({ top: '0%' }))
          ],optional),
        ]),
      ]),
      transition('isScvDeckLength => isScvKms, isScvBodyType => isScvDeckLength, isScvBaseVehicle => isScvBodyType',[  
        style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          // bottom: '-20%',
        //   left: 0,
        top:'0%',
          width: '100%'
        })
      ],optional),
      query(':enter', [
        style({ top: '-100%' })
      ],optional),
      query(':leave', [animateChild()],optional),
      group([
        query(':leave', [
          animate('1000ms ease-out', style({ top: '100%' }))
        ],optional),
        query(':enter', [
          animate('1200ms ease-out', style({ top: '0%' }))
        ],optional),
      ]),]),

      transition('isScvBaseVehicle => isScvVas',[
        group([
          query(':leave', [
            animate('580ms ease-out', style({ opacity: 0 }))
          ],optional),
          query(':enter', [
            animate('500ms ease-out', style({ opacity: 1 }))
          ],optional)  
        // query(':enter', [
        // style({
        //   opacity: 1
        // }),
        // animate('800ms ease-out', style({
        //   opacity: 0
        // }))
      ]),]),

   //transitions for Bus lob
   transition('void => isBusFuel', [
    style({ position: 'relative' }),
    query(':enter, :leave', [
      style({
        position: 'absolute',
        // bottom: '-20%',
      //   left: 0,
      top:'0%',
      // bottom:'0%',
        width: '100%'
      })
    ],optional),
    query(':enter', [
      style({ top: '100%'})
    ],optional),
    query(':leave', [animateChild()],optional),
    group([
      query(':leave', [
        animate('1000ms ease-out', style({ top: '-100%'}))
      ],optional),
      query(':enter', [
        animate('1200ms ease-out', style({ top: '0%' }))
      ],optional),
    ]),
  ]),
  transition('isBusFuel => isBusApplication, isBusApplication => isBusPaxCapacity, isBusPaxCapacity => isBusVentilation, isBusVentilation => isBusSeatLayout, isBusSeatLayout => isBusBuildOption', [
    style({ position: 'relative' }),
    query(':enter, :leave', [
      style({
        position: 'absolute',
        // bottom: '-20%',
      //   left: 0,
      top:'0%',
      // bottom:'0%',
        width: '100%'
      })
    ],optional),
    query(':enter', [
      style({ top: '100%'})
    ],optional),
    query(':leave', [animateChild()],optional),
    group([
      query(':leave', [
        animate('1000ms ease-out', style({ top: '-100%'}))
      ],optional),
      query(':enter', [
        animate('1200ms ease-out', style({ top: '0%' }))
      ],optional),
    ]),
  ]),
  transition('isBusApplication => isBusFuel, isBusPaxCapacity => isBusApplication, isBusVentilation => isBusPaxCapacity, isBusSeatLayout => isBusVentilation, isBusBuildOption => isBusSeatLayout',[  
    style({ position: 'relative' }),
  query(':enter, :leave', [
    style({
      position: 'absolute',
      // bottom: '-20%',
    //   left: 0,
    top:'0%',
      width: '100%'
    })
  ],optional),
  query(':enter', [
    style({ top: '-100%' })
  ],optional),
  query(':leave', [animateChild()],optional),
  group([
    query(':leave', [
      animate('1000ms ease-out', style({ top: '100%' }))
    ],optional),
    query(':enter', [
      animate('1200ms ease-out', style({ top: '0%' }))
    ],optional),
  ]),]),

  ]);
 
  